import * as Constants from '../constants';

const initialState = {

};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case Constants.ACTIVE_PAGE:
      return {
        ...state,
        activePage: action.payload.page,
      };
    case Constants.EXAMPLE_FORM:
      return {
        ...state,
        exampleForm: action.payload.form,
      };
    default:
      return state;
  }
};

export default reducer;
